export enum ContestTypeEnum {
    PUBLIC          = 1,
    PRIVATE         = 2
}
